import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  TextField,
  Stack,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";

export const ThreeSlotDepositModal = ({
  open,
  onClose,
  currentBalance,
  onDepositSuccess,
  currency = "BET",
}) => {
  const [depositAmount, setDepositAmount] = useState("500");

  const quickAmounts = ["100", "250", "500", "1000", "2500"];

  const handleDeposit = () => {
    const amt = parseFloat(depositAmount);
    if (isNaN(amt) || amt <= 0) {
      toast.error("Please enter a valid deposit amount");
      return;
    }
    const newBal = (parseFloat(currentBalance || 0) + amt).toFixed(2);
    onDepositSuccess(newBal);
    toast.success(`Successfully deposited ${currency} ${amt.toLocaleString()} to your balance!`);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          background: "linear-gradient(180deg, #090e17 0%, #0f172a 100%)",
          border: "2px solid #22c55e",
          boxShadow: "0 0 35px rgba(34, 197, 94, 0.35)",
          color: "#ffffff",
          p: 1.5,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
          pb: 1.5,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              p: "6px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #22c55e, #15803d)",
              display: "flex",
            }}
          >
            <AccountBalanceWalletIcon sx={{ color: "#ffffff", fontSize: 22 }} />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 900, color: "#86efac" }}>
            DEPOSIT FUNDS
          </Typography>
        </Stack>
        <IconButton onClick={onClose} sx={{ color: "#94a3b8" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{ mb: 2, textAlign: "center", p: 1.5, borderRadius: "12px", bgcolor: "rgba(30, 41, 59, 0.6)" }}>
          <Typography variant="caption" sx={{ color: "#94a3b8" }}>
            Current Balance
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 900, color: "#fef08a" }}>
            {currency} {parseFloat(currentBalance || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </Typography>
        </Box>

        <Typography variant="caption" sx={{ color: "#94a3b8", display: "block", mb: 1 }}>
          Select or enter amount to deposit ({currency}):
        </Typography>

        <TextField
          fullWidth
          type="number"
          value={depositAmount}
          onChange={(e) => setDepositAmount(e.target.value)}
          placeholder="0.00"
          InputProps={{
            startAdornment: <Typography sx={{ color: "#86efac", fontWeight: 800, mr: 1 }}>{currency}</Typography>,
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              bgcolor: "rgba(15, 23, 42, 0.8)",
              color: "#ffffff",
              fontWeight: 800,
              fontSize: "1.2rem",
              borderRadius: "12px",
              "& fieldset": { borderColor: "#22c55e" },
              "&:hover fieldset": { borderColor: "#4ade80" },
            },
          }}
        />

        <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ gap: 1, mb: 2 }}>
          {quickAmounts.map((amt) => (
            <Chip
              key={amt}
              label={`+${currency} ${amt}`}
              onClick={() => setDepositAmount(amt)}
              sx={{
                bgcolor: depositAmount === amt ? "#22c55e" : "rgba(30, 41, 59, 0.8)",
                color: depositAmount === amt ? "#0f172a" : "#ffffff",
                fontWeight: 800,
                cursor: "pointer",
                border: "1px solid rgba(34, 197, 94, 0.4)",
                "&:hover": { bgcolor: "#22c55e", color: "#0f172a" },
              }}
            />
          ))}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          fullWidth
          variant="contained"
          startIcon={<AddCircleIcon />}
          onClick={handleDeposit}
          sx={{
            py: 1.2,
            borderRadius: "12px",
            background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
            color: "#ffffff",
            fontWeight: 900,
            fontSize: "1rem",
            textTransform: "uppercase",
            boxShadow: "0 4px 14px rgba(34, 197, 94, 0.4)",
            "&:hover": {
              background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
            },
          }}
        >
          Confirm Deposit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThreeSlotDepositModal;
